import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { Table } from "../../../../components/table/Table";
import { getBlockedDevicesForTable } from "../../../../store/devices/devices.selectors";
import { InfectionsList } from "../../../../components/infectionsList/InfectionsList";
import { Manufacturer } from "../../../../components/manufacturer/Manufacturer";
import { Mobile, NotMobile } from "../../../../hocs/Responsive";
import { useIntlTranslate } from "../../../../hooks";
import {
  COLUMNS,
  COLUMNS_MOBILE,
  INITIAL_SORT,
  SEARCH_KEYS,
} from "./BlockedDevicesTable.consts";
import { BlockedDevicesTableHeader } from "./components";

export const BlockedDevicesTable = () => {
  const devices = useSelector(getBlockedDevicesForTable, _.isEqual);
  const translate = useIntlTranslate();
  const caption = translate("blocked");

  return (
    <Fragment>
      <Mobile>
        <Table
          header={<BlockedDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          visibleHeader={false}
          data={devices}
          columns={COLUMNS_MOBILE}
          hiddenColumns={["identifiers", "flatInfections", "manufacturer"]}
          renderRowSubComponent={renderRowSubComponent}
          defaultSorted={INITIAL_SORT}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </Mobile>
      <NotMobile>
        <Table
          header={<BlockedDevicesTableHeader />}
          searchKeys={SEARCH_KEYS}
          showPagination
          columns={COLUMNS}
          data={devices}
          defaultSorted={INITIAL_SORT}
          searchAriaLabelMessage="aria_search_for_device"
          caption={caption}
        />
      </NotMobile>
    </Fragment>
  );
};

const renderRowSubComponent = ({
  row: {
    original: { infections, manufacturer },
  },
}) => {
  return (
    <div className={"sub-row-content"} data-testid="blocked-device-sub-row">
      <div className={"sub-row-content__item"}>
        <div className={"sub-row-content__header"}>
          <FormattedMessage id={"manufacturer"} />
        </div>
        <Manufacturer manufacturer={manufacturer} />
      </div>
      <InfectionsList infections={infections} />
    </div>
  );
};
